<div class="title" mat-dialog-title>
  <div class="title-breadcrumb">
    <mat-icon [svgIcon]="IconNames.ice_power" />
    <a
      class="search-page-link"
      data-testid="search-page-link"
      tabindex="0"
      [ngClass]="{ 'active-title-text': !selectedAccessoryItem }"
      (click)="selectedAccessoryItem = null"
      (keydown.enter)="selectedAccessoryItem = null"
    >
      Tilbehør
    </a>
    @if (selectedAccessoryItem) {
      <span>/</span>
      <span class="active-title-text">Spesifiser</span>
    }
  </div>
  <app-ice-icon-button
    matDialogClose
    size="40px"
    testId="close-accessory-search-dialog-button"
    [iconName]="IconNames.ice_close"
  />
</div>
<div mat-dialog-content>
  @if (!selectedAccessoryItem) {
    <div class="hardware-search">
      <div class="search-filter-wrapper">
        <div class="hardware-search-filters">
          <div class="search-filters">
            <app-ice-search-field
              placeholder="Søk etter produkter"
              [value]="searchValue"
              (searchTriggered)="onSearchChange($event)"
            />

            <app-accessory-filters
              [accessoryFilters]="accessoryFilters()"
              [isLoadingAccessoryFilters]="isLoadingAccessoryFilters()"
              [isLoadingSearchResults]="isLoadingAccessorySearchResults()"
              (mainCategoryChange)="onMainCategoryChange($event)"
              (manufacturerChange)="onManufacturerChange($event)"
              (onlyDisplayEligibleForAccessoryBinding)="onlyDisplayEligibleForAccessoryBinding($event)"
              (subCategoryChange)="onSubCategoryChange($event)"
            />
          </div>
        </div>
      </div>
      <div class="search-result-wrapper">
        <app-hardware-search-result
          [accessories]="accessories"
          [defaultImage]="(selectedTheme$ | async).accessories_illustration"
          [displayType]="displayType"
          [isAccessories]="true"
          [isLoadingSearchResults]="isLoadingAccessorySearchResults()"
          [isManualRegistrationSupported]="false"
          (changeDisplayType)="onDisplayTypeChange($event)"
          (itemClicked)="selectAccessoryItem($event)"
        />
      </div>
    </div>
  } @else {
    <div class="hardware-details-wrapper">
      <app-accessory-details
        [accessoryItem]="selectedAccessoryItem"
        [warehouseState]="warehouseState()"
        (addAccessory)="onAddAccessoryItem($event)"
        (backToSearch)="selectedAccessoryItem = null"
      />
    </div>
  }
</div>
